import styled from 'styled-components';
import { GREY1, WHITE } from '@swegon-core/uic/dist/src/theme';

export const Header = styled.header`
    background: ${WHITE};
    display: flex;
    position: relative;
    align-items: center;
    left: 0;
    top: 0;
    right: 0;
    padding: 8px 16px;
    box-sizing: border-box;
    select {
        background-color: ${WHITE};
    }
`;

export const Title = styled.h6`
    align-items: center;
    display: flex;
    padding-left: 20px;
    margin: 0px;
`;
export const Subtitle = styled.p`
    align-items: center;
    display: flex;
    padding-left: 20px;
`;

export const ContentRight = styled.div`
    display: flex;
    gap: 0.3125rem;
    list-style: none;
    margin-left: auto;
`;

export const PrintOptionContainer = styled.div``;

export const HeaderItem = styled.div`
    margin: 0.3rem;
    display: flow-root;
`;

export const HeaderItemDivider = styled.div`
    border-left: 1px ${GREY1} solid;
    width: 1px;
    height: 70%;
`;

export const HeaderItemsContainer = styled.div`
    display: inline-flex;
    align-items: flex-end;
`;

export const PrintButtonContainer = styled.div`
    display: block;
    width: 100px;
    margin-right: 10px;
`;

export const SelectPrintLabel = styled.label``;
